import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ul",
  "ol",
  "li",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "blockquote",
  "code",
  "pre",
  "span",
  "div",
];

const ALLOWED_ATTR = ["href", "title", "target", "rel", "style"];

const SAFE_TEXT_ALIGN = /^(?:\s*text-align\s*:\s*(?:left|center|right|justify)\s*;?\s*)+$/i;

function looksLikeHtml(text: string): boolean {
  return /<[a-z][\s\S]*>/i.test(text);
}

function escapePlainText(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/\n/g, "<br>");
}

let hooksRegistered = false;

function ensureStyleHook() {
  if (hooksRegistered) return;
  hooksRegistered = true;
  DOMPurify.addHook("uponSanitizeAttribute", (_node, data) => {
    if (data.attrName !== "style") return;
    if (!SAFE_TEXT_ALIGN.test(data.attrValue || "")) {
      data.keepAttr = false;
    }
  });
}

/** True when tip has visible text (ignores empty HTML shells). */
export function hasCommissioningTip(tip?: string | null): boolean {
  const raw = (tip || "").trim();
  if (!raw) return false;
  const textOnly = DOMPurify.sanitize(raw, { ALLOWED_TAGS: [] }).trim();
  return textOnly.length > 0;
}

/** Sanitize tip HTML for safe rendering; plain text keeps line breaks. */
export function sanitizeCommissioningTipHtml(tip?: string | null): string {
  const raw = (tip || "").trim();
  if (!raw) return "";
  const source = looksLikeHtml(raw) ? raw : escapePlainText(raw);
  ensureStyleHook();
  return DOMPurify.sanitize(source, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|\/|#)/i,
  });
}
